@if (form) {
  <span [formGroup]="form">
    <mat-form-field [ngStyle]="styles" subscriptSizing="dynamic" appearance="fill">
      <span matPrefix>{{ prefix }}</span>
      @if (prefixIcon) {
        <mat-icon matPrefix>{{ prefixIcon }}</mat-icon>
      }
      <mat-label>{{ placeHolder }}</mat-label>
      <input
        matInput
        [id]="inputId"
        [type]="type === 'password' && !hide ? 'text' : type"
        [placeholder]="placeHolder"
        [formControlName]="formControlName"
        [autocomplete]="autocomplete"
        (keyup)="keyUpChange.emit()"
        ngDefaultControl
        />
      @if (type !== 'password') {
        <span matSuffix>{{ suffix }}</span>
      }
      @if (type === 'password' && !disableShowPassword) {
        <button type="button" mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
          <mat-icon color="accent">{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      }
      @if (suffixIcon) {
        <mat-icon matSuffix>{{ suffixIcon }}</mat-icon>
      }
      @if (error) {
        <mat-error>{{ error }}</mat-error>
      }
    </mat-form-field>
  </span>
} @else {
  <span>
    <mat-form-field [ngStyle]="styles" subscriptSizing="dynamic" appearance="fill">
      <span matPrefix>{{ prefix }}</span>
      @if (prefixIcon) {
        <mat-icon matPrefix>{{ prefixIcon }}</mat-icon>
      }
      <mat-label>{{ placeHolder }}</mat-label>
      <input
        matInput
        [id]="inputId"
        [placeholder]="placeHolder"
        [type]="type === 'password' && !hide ? 'text' : type"
        [autocomplete]="autocomplete"
        [(ngModel)]="value"
        (ngModelChange)="basicOnChange($event)"
        (change)="blurOnChange($event.target)"
        [disabled]="disabled"
        (keyup)="keyUpChange.emit()"
        ngDefaultControl
        />
      @if (type !== 'password') {
        <span matSuffix>{{ suffix }}</span>
      }
      @if (type === 'password' && !disableShowPassword) {
        <button type="button" mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
          <mat-icon color="accent">{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      }
      @if (suffixIcon) {
        <mat-icon matSuffix>{{ suffixIcon }}</mat-icon>
      }
    </mat-form-field>
    @if (error) {
      <mat-error>{{ error }}</mat-error>
    }
  </span>
}
